<template>
  <div
    class="bb-color-picker"
    :style="popupPosition"
    @mouseleave="onMouseLeave()"
  >
    <div
      class="bb-color-picker__item"
      v-for="(color, index) in colorPickerList"
      :key="color.id"
      :style="{background: color.rgba}"
      @click="onChangeActive(color, index)"
    >
      <div
        v-if="index === activeIndex"
        class="bb-color-picker__icon"
        v-html="OkIconDefault()"
      />
    </div>
  </div>
</template>

<script>
import { COLOR_PICKER_LIST } from '@/constants/colorPickerList'
import { OkIconDefault } from '@/constants/icon'

export default {
  name: 'BBColorPicker',
  props: {
    defaultColor: {
      type: String,
      default: ''
    },
    popupPosition: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    OkIconDefault,
    colorPickerList: COLOR_PICKER_LIST,
    activeIndex: 0
  }),
  methods: {
    onChangeActive ({key}, index) {
      this.activeIndex = index
      this.$emit('onChangeActiveColor', key)
    },
    setDefaultValue () {
      const index = this.colorPickerList.findIndex((el) => el.key === this.defaultColor)
      this.activeIndex = index
    },
    onMouseLeave () {
      this.$emit('update:isShowColorPicker', false)
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-color-picker {
    display: grid;
    grid-template-columns: repeat(6, 22px);
    grid-gap: 8px 8px;
    position: absolute;
    z-index: 20;
    padding: 13px 13px 13px 13px;
    border-radius: 5px;
    background: $color-white;
    box-shadow: 0 0 12px  rgba($color-black, 0.12);

    &__item {
      width: 22px;
      height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
    }

    &__icon {
      display: flex;
    }
  }
</style>

<style lang="scss">
@import "../../../sass/variables";

  .bb-color-picker {

    &__icon {
      svg path {
        fill: $color-white;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBColorPicker/BBColorPicker.vue